export default function () {
  const widgetName = "agZoneFooterBackground";
  const widgetOpts = agZoneFooterBackgroundOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    hasImages: true,
    textOverImage: true,
    imageIsBackground: true,
    lazyLoadImages: false,
    showDescription: false,
    moreButton: false,
    buyNowButton: false,
    link: [""],

    cardWidgetLoaded: function (data) {
      const bgImage = data.items[0].ImageWithPath;

      $(".ag-zone-footer").css(
        "background-image",
        "url(" + `"${bgImage}"` + ")"
      );
    },
  });
}
